import { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import UECard from "../UECard";
import ModalPopup from "../ModalPopup";
import { readCurrentState, sendCurrentState, StepContext } from "../StepContext";
import TipoIndAutoSuggest from "../autocomplete/tipo.autosuggest";
import IndirizzoAutoSuggest from "../autocomplete/indirizzo.autosuggest";
import ComuneAutoSuggest from "../autocomplete/comune.autosuggest";
import useQuery from "../../hooks/useQuery";

import img_elettricita from "../../img/elettricita.png"
import img_gas from "../../img/gas.png"

var msgText = '';
var msgTitle = '';

var readURLParams = true;

function validatePOD(POD) {
    const re = /^IT([0-9]{3})E([0-9]{7})([0-9A-Z]{1})$/;
    return re.test(POD);
}

export function validatePDR(PDR) {
    //Lista PDR che sollevano eccezione
    const esclusioni = ['00000000000000','11111111111111','22222222222222','33333333333333',
                        '44444444444444','55555555555555','66666666666666','77777777777777',
                        '88888888888888','99999999999999','01234567890123','12345678912345',
                        '12345678901234']
    //Se il PDR specificato è incluso nella lista di esclusioni
    //la funzione ritorna esito false
    if (esclusioni.includes(PDR))
    {   
        return false;
    }

    const re = /^([0-9]{14})$/;
    return re.test(PDR);
}


var offerteE = [
 /*   { key:1,fornitura: "E", id: "41", ot: "1347", descrizione: "*LUCE WEB",pf:true },
    { key:2,fornitura: "E", id: "48", ot: "1348", descrizione: "*LUCE WEB multioraria",pf:true },
    { key:3,fornitura: "E", id: "31", ot: "1358", descrizione: "*ACQUISTA COME NOI - Domestico SPREAD",pf:true },
    { key:4,fornitura: "E", id: "40", ot: "1359", descrizione: "*ACQUISTA COME NOI - Luce Altri Usi SPREAD",pf:false },
   // { key:4,fornitura: "E", id: "13", ot: "1301", descrizione: "ACQUISTA COME NOI",pf:true },*/
];

var offerteG = [
  /*  { key:1, fornitura: "G", id: "49", ot: "1391", descrizione: "*GAS WEB",pf:true },
    { key:2,fornitura: "G", id: "44", ot: "1387", descrizione: "*QUICK GAS",pf:true },
    { key:3, fornitura: "G", id: "46", ot: "1390", descrizione: "*QUICK GAS - Altri usi",pf:false },
  //  { key:4,fornitura: "G", id: "17", ot: "1315", descrizione: "ACQUISTA COME NOI",pf:true }*/
];

export function getListaOfferte(query) {
    var aga = readCurrentState('aga');
    if ((aga=='')||(aga==undefined)){
        aga = 29;

        if (query.has("aga")){
            aga = query.get("aga");
        }
    }
    fetch(process.env.REACT_APP_API_URL+`contratti/offerte/`+aga,
    {
        method: 'GET',
        headers: {
            'content-type': 'application/json'
        }/*,
        body: JSON.stringify(StepContext.contratto)*/
    })
    .then(response => {
        if(response.ok){
            return response.json()
        }else{
//            throw new Error('Error...')
        }
    }
    ).then(
        json=>{
            offerteE = json.offerte_e;
            offerteG = json.offerte_g;
            let k = 1;
            offerteE.map((offerta)=>{
                offerta.key = k;
                k++;
            }); 
            k = 1;
            offerteG.map((offerta)=>{
                offerta.key = k;
                k++;
            }); 
            //console.log(offerteE); 
            //console.log(offerteG); 
        }
    )
    .catch(
        (error)=> {console.error(error);}
    );    
}

function findOffertaByID(tipo,id){
    let offerte = {};
    
    if (tipo=='E'){
        offerte = offerteE;
    } else if (tipo=='G'){
        offerte = offerteG;
    }

    let R = null;

    offerte.map((offerta)=>{ if (offerta.id==id){ R = offerta;} });

    return R;

}


function ListaOfferte(props) {

    let query = useQuery();

    const [selezione, setSelezone] = useState(0);

    const activeOption = (id) => {
        let active = "ue btn btn-q btn-yellow active_f";
        let noactive = "ue btn btn-q btn-yellow";

        if (id == props.selezione) {
            return active;
        } else {
            return noactive;
        }
    }
    const handleClick = (e) => {
        setSelezone(e);
        if (props.onClick)
            props.onClick(e);
    }

    let img_f = null;
    if(props.tipo==="E"){
        img_f = img_elettricita;
    }else if(props.tipo==="G"){
        img_f = img_gas;
    }

    
    function disabilitaTastiOfferta(id) {
        if (query.has("oE")) {
            return props.selezione!=id ;
        }
        if (query.has("oG")) {
            return props.selezione!=id ;
        }
    }
    if ((props.Offerte==undefined)||(props.Offerte==null)||(props.Offerte.length==0)){
        return <><h3 style={{borderStyle:"thin",borderColor:"red",borderRadius:"15px",backgroundColor:"lightyellow",margin:"5px",padding:"5px"}}>Siamo Spiacenti per l'inconventiente ma al momento non è disponibile nessuna offerta, contatta il servizio clienti per maggiori informazioni.</h3></>   
    }else{    
        const lista = props.Offerte.map((offerta) => <button key={offerta.id} className={activeOption(offerta.id)} onClick={handleClick.bind(this, offerta)} disabled={disabilitaTastiOfferta(offerta.id)}><span><img src={img_f}></img></span><br />{offerta.descrizione}</button>);
        return <>{lista}</>
    }
    
}

function maxConsumiEE(){
    if(readCurrentState('uso_ee')==20){
        //Domestico
        return 10000;
    }else{
        //Altri USI
        return 1000000;
    }
}

function maxConsumiGAS(){
    if((readCurrentState('uso_gas')==10)||(readCurrentState('uso_gas')==15)){
        //Domestico
        return 5000;
    }else{
        //Altri USI
        return 100000;
                
    }    
}

function maxPotenza(){
    if(readCurrentState('uso_ee')==20){
        //Domestico
        return 30;
    }else{
        //Altri USI
        return 1000;
    }
}

function Step5() {
    let query = useQuery();

    const [modalShow, setModalShow] = useState(false);

    const [fornitura, setFornitura] = useState("E");//fornitura da get visualizzazione lista offerta E= Energia G=Gas

    const [offertaEE, setOffertaEE] = useState("");
    const [offertaEEObj, setOffertaEEObj] = useState({});
    const [offertaEE_desc, setOffertaEE_desc] = useState("");
    const [offertaEE_OT, setOffertaEE_OT] = useState("");
    const [offertaGAS, setOffertaGas] = useState("");
    const [offertaGASObj, setOffertaGasObj] = useState({});
    const [offertaGAS_desc, setOffertaGas_desc] = useState("");
    const [offertaGAS_OT, setOffertaGas_OT] = useState("");

    const [pod, setPOD] = useState("");
    const [pdr, setPDR] = useState("");
    const [conAnnuoPrevEE, setConAnnuoPrevEE] = useState("");
    const [conAnnuoPrevGAS, setConAnnuoPrevGAS] = useState("");
    const [potenza, setPotenza] = useState("");

    const [comune, setComune] = useState({});
    const [comuneDesc, setComuneDesc] = useState("");
    const [cap, setCAP] = useState("");
    const [eletopo, setEletopo] = useState("");
    const [elet_id, seEletID] = useState("");
    const [telet_id, setTeletID] = useState("");
    const [telet, setTelet] = useState("");
    const [numero, setNumero] = useState("");
    const [suffisso, setSuffisso] = useState("");

    const { step, setStep } = useContext(StepContext);


    useEffect(() => {

        if(readCurrentState("fornitura")=='ee')
            setFornitura('E')
        else if(readCurrentState("fornitura")=='gas')
            setFornitura('G');

        getListaOfferte(query);
        //console.log('step: '+step);
        if (query.has("fa"))
            setFornitura(query.get("fa"));

        if(readURLParams || step<5){
            MostraDatiGet();
            readURLParams = false;
        }else{
            MostraDatiGet();
            MostraDatiLocalStorage();
        }

    }, []);


    function MostraDatiGet(){
        //console.log("MostraDatiGet");

        if (query.has("oE")) {
            let oE = query.get("oE");
            let offerta = findOffertaByID('E',oE);
            if( offerta != null){
                setOffertaEE(offerta.id);
                setOffertaEEObj(offerta);
                setOffertaEE_OT(offerta.ot);
                setOffertaEE_desc(offerta.descrizione);
            }
        }
        if (query.has("oG")) {
            let oG = query.get("oG");
            let offerta = findOffertaByID('G',oG);
            if( offerta != null){
                setOffertaGas(offerta.id);
                setOffertaGasObj(offerta);
                setOffertaGas_OT(offerta.ot);
                setOffertaGas_desc(offerta.descrizione);
            }
        }

        if (query.has("potenza")) {
            setPotenza(query.get("potenza"));
        }
    }

    function MostraDatiLocalStorage() {
        console.log(readCurrentState("fornitura"));

        let oE = readCurrentState("offertaEE");
        let offertaE = findOffertaByID('E',oE);
        if( offertaE != null){
            setOffertaEE(offertaE.id);
            setOffertaEE_OT(offertaE.ot);
            setOffertaEE_desc(offertaE.descrizione);
            setOffertaEEObj(offertaE);
        }

        let oG = readCurrentState("offertaGAS");
        let offertaG = findOffertaByID('G',oG);
        if( offertaG != null){
            setOffertaGas(offertaG.id);
            setOffertaGas_OT(offertaG.ot);
            setOffertaGas_desc(offertaG.descrizione);
            setOffertaGasObj(offertaG);
        }
    
        setPOD(readCurrentState("pod"));
        setPDR(readCurrentState("pdr"));
        setConAnnuoPrevEE(readCurrentState("conAnnuoPrevEE"));
        setConAnnuoPrevGAS(readCurrentState("conAnnuoPrevGAS"));
        setPotenza(readCurrentState("potenza"));

        let comune_tmp = {
            com_id: readCurrentState("uf_comune"),
            com_des: readCurrentState("uf_descrizione_comune"),
            com_cap: readCurrentState("uf_cap")
        }
        setComune(comune_tmp);
        setCAP(readCurrentState("uf_cap"));
        setNumero(readCurrentState("uf_civico"));
        setSuffisso(readCurrentState("uf_suffisso"));
        setComuneDesc(comune_tmp.com_des);//Aggiunto 
        setEletopo(readCurrentState("uf_via")); //Aggiunto 
        setTelet(readCurrentState("uf_toponimo")) //Aggiunto 
        setTeletID(readCurrentState("uf_id_toponimo")) //Aggiunto
    }

    function ModuloOfferteEE() {
        //console.log(fornitura);
        if ((fornitura === "E") || (fornitura === ""))
            return (
                <Col className="text-center text-md-right">
                    <ListaOfferte tipo="E" Offerte={offerteE} selezione={offertaEE}  onClick={(e) => { setOffertaEE(e.id); setOffertaEE_desc(e.descrizione); setOffertaEE_OT(e.ot); setOffertaEEObj(e);}} />
                </Col>);
    }
    function ModuloOffertGas() {
        if ((fornitura === "G") || (fornitura === ""))
            return (
                <Col className="text-center text-md-right">
                    <ListaOfferte tipo="G" Offerte={offerteG} selezione={offertaGAS}  onClick={(e) => { setOffertaGas(e.id); setOffertaGas_desc(e.descrizione); setOffertaGas_OT(e.ot); setOffertaGasObj(e); }} />
                </Col>);
    }

    function ModuloDatiTecniciEE() {
        if ((fornitura === "E") || (fornitura === ""))
        return <>
            <Col>
                <h3 style={{ margin: "0 auto", maxWidth: "800px", textAlign: "center" }}>
                    Dati tecnici fornitura Luce
                </h3>
                <Row className="justify-content-center" style={{ display: 'flex' ,paddingLeft:"15px" }} >
                    <Col>
                        <label htmlFor="intes">
                            Codice POD*<br />
                            <input type="text" className="ue ue-text" id="intes" placeholder="" maxLength="14"
                                value={pod} onChange={(e) => { setPOD(e.target.value.toUpperCase()) }} />
                        </label>
                    </Col>
                    <Col>
                        <label htmlFor="intes">
                            Consumo Annuo Previsto in kWh<br />
                            <input type="number" className="ue ue-text" id="intes" placeholder="" maxLength="5" 
                                value={conAnnuoPrevEE} onChange={(e) => {if(e.target.value>maxConsumiEE()){return} setConAnnuoPrevEE(e.target.value) }} />
                        </label>
                    </Col>
                    <Col>
                        <label htmlFor="intes">
                            Potenza in kW*<br />
                            <input type="number" className="ue ue-text" placeholder=""
                                maxLength="3" value={potenza} onChange={(e) => {if(e.target.value>maxPotenza()){return} setPotenza(e.target.value) }} />
                        </label>
                    </Col>
                </Row>
            </Col>
        </>
    }

    function ModuloDatiTecniciGas() {
        if ((fornitura === "G") || (fornitura === ""))
        return <>
            <Col style={{ margin: "0 auto", maxWidth: "800px", textAlign: "center" }}>
                <h3 style={{ margin: "0 auto", maxWidth: "800px", textAlign: "center" }}>
                    Dati tecnici fornitura Gas
                </h3>
                <Row className="justify-content-center" style={{ display: 'flex' }} >
                    <Col>
                        <label htmlFor="intes">
                            Codice PDR*<br />
                            <input type="text" className="ue ue-text"  placeholder="" maxLength="14"
                                value={pdr} onChange={(e) => { setPDR(e.target.value) }} />
                        </label>
                    </Col>
                    <Col>
                        <label htmlFor="intes">
                            Consumo Annuo Previsto in SMC<br />
                            <input type="number" className="ue ue-text"  placeholder=""
                                maxLength="10" value={conAnnuoPrevGAS} onChange={(e) => {if(e.target.value>maxConsumiGAS()){return}   setConAnnuoPrevGAS(e.target.value) }} />
                        </label>
                    </Col>
                </Row>
            </Col>
        </>
    }

   /* function ModuloUbicazione() {
        return <>
            <h3 style={{ margin: "0 auto", maxWidth: "800px", textAlign: "center" }}>
                Ubicazione della Fornitura
            </h3>
            <Container className="container-fluid">
                <Row className="justify-content-center" style={{ display: 'flex' }} >
                    <Col className="col-md-auto">
                        <label htmlFor="comune" >
                            Comune*<br />
                            <ComuneAutoSuggest inputText={comuneDesc} id="comune" onSelectValue={(s) => { setComune(s); setCAP(s.com_cap); }} />
                        </label>
                    </Col>
                    <Col className="col-md-auto">
                        <label htmlFor="cap">
                            CAP<br />
                            <input type="text" className="ue ue-text" id="cap" placeholder="CAP"
                                maxLength="5" value={cap} onChange={(e) => { setCAP(e.target.value) }} />
                        </label>
                    </Col>

                </Row>
                <Row className="justify-content-center" style={{ display: 'flex' }} >
                    <Col className="col-md-auto">
                        <label htmlFor="tipo" >
                            Tipo indirizzo* (Via, Piazza, Strada...)<br />
                            <TipoIndAutoSuggest inputText={telet} id="tipo" onSelectValue={(s) => { setTeletID(s.telet_id); setTelet(s.telet_des) }} onChange={(e) => { setTelet(e); setTeletID(""); setTelet("") }} />
                        </label>
                    </Col>
                    <Col className="col-md-auto">
                        <label htmlFor="via">
                            Indirizzo*<br />
                            <IndirizzoAutoSuggest inputText={eletopo} com_id={comune.com_id} id="via" onSelectValue={(s) => { seEletID(s.elet_id); setEletopo(s.indirizzo) }} onChange={(e) => { setEletopo(e) }} />
                        </label>
                    </Col>
                </Row>
                <Row className="justify-content-center" style={{ display: 'flex' }} >
                    <Col className="col-md-auto">
                        <label htmlFor="numero" >
                            Numero*<br />
                            <input type="text" className="ue ue-text" id="numero" placeholder="Numero Civico"
                                value={numero} onChange={(e) => { setNumero(e.target.value) }} />
                        </label>
                    </Col>
                    <Col className="col-md-auto">
                        <label htmlFor="suffisso">
                            Suffisso<br />
                            <input type="text" className="ue ue-text" id="suffisso" placeholder="Suffisso"
                                value={suffisso} onChange={(e) => { setSuffisso(e.target.value.toUpperCase()) }} />
                        </label>
                    </Col>
                </Row>
            </Container>
        </>
    }
    */

    function ValidaCongruenzaContratto(){
        msgText = "Opzioni di attivazione offerta";

        function ValidaLocal(offertaLocal,f){
            let Obj = {};
            if (f=='E'){
                Obj = offertaEEObj;
            }else if (f=='G'){
                Obj = offertaGASObj;
            }
            console.debug(Obj);
            if ((offertaLocal != "")) {    
                if(Obj.mod_pagam_richiesta!=""){
                    if(String(readCurrentState('modPagamento'))!=String(Obj.mod_pagam_richiesta)){
                        msgTitle = 'Il metodo di pagamento selezionato non è compatibile con l\'offerta che si intende attivare.';
                        setModalShow(true);                    
                        return false;
                    }
                }
                if(Obj.mod_sped_richiesta!=-1){
                    if(readCurrentState('tipoIn')!=Obj.mod_sped_richiesta){
                        msgTitle = 'Il metodo di invio fatture selezionato non è compatibile con l\'offerta che si intende attivare.';
                        setModalShow(true);                    
                        return false;
                    }
                }
                if(Obj.solo_pers_fisica!=-1){
                    let pf = "true";
                    if((Obj.solo_pers_fisiche==0)||(Obj.solo_pers_fisiche=="0")||(Obj.solo_pers_fisiche==undefined)){
                        pf = "false";
                    }
                    console.debug(pf+'+++'+Obj.solo_pers_fisiche+'+++'+String(readCurrentState('pf')))
                    if(String(readCurrentState('pf'))!=pf){
                        msgTitle = 'L\'offerta che si intende attivare non è consentita per la tipologia di utenza scelta.';
                        setModalShow(true);                    
                        return false;
                    }
                }
                
            }
            return true;
        }

        if(!ValidaLocal(offertaEE,'E')){ 
            console.error('Errore validazione conformità offerta E');
            return false;
        };
        if(!ValidaLocal(offertaGAS,'G')){ 
            console.error('Errore validazione conformità offerta G');
            return false;
        };

        return true;
    }


    function Validation() {
        let conx = {};

        if ((fornitura === "E") || (fornitura === "")){
            if (offertaEE === "") {
                msgText = "Seleziona l'offerta da attivare per la Luce.'";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
        
            if (!validatePOD(pod)) {
                msgText = "Inserisci un codice POD valido. Trovi questa informazioni sulla fattura del tuo attuale fornitore. Il formato previsto è IT seguito da tre numeri, la lettera E e altri 8 numeri (ad esempio IT123E12345678).";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
            
            if(conAnnuoPrevEE.trim().length>0){
                if(isNaN(conAnnuoPrevEE)){
                    msgText = "Inserisci un consumo annuo previsto per la Luce valido.";
                    msgTitle = 'Informazioni non valide o mancanti';
                    setModalShow(true);
                    return false;                    
                }
            }
            // Ticket#1000002136
            //if(String(potenza).trim().length>0){
                if((String(potenza).trim().length==0)||(isNaN(potenza))){
                    msgText = "Inserisci un potenza in KWh valida, solo parte numerica. Puoi trovare questa informazione nella fattura del tuo attuale fornitore.";
                    msgTitle = 'Informazioni non valide o mancanti';
                    setModalShow(true);
                    setPotenza(3);
                    return false;                    
                }
            //}
        }
        if ((fornitura === "G") || (fornitura === "")){
            if (offertaGAS === "") {
                msgText = "Seleziona l'offerta da attivare per il Gas.";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
            if (!validatePDR(pdr)) {
                msgText = "Inserisci un codice PDR valido. Trovi questa informazioni sulla fattura del tuo attuale fornitore.'";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
            if(conAnnuoPrevGAS.trim().length>0){
                if(isNaN(conAnnuoPrevGAS)){
                    msgText = "Inserisci un consumo annuo previsto per il Gas valido.";
                    msgTitle = 'Informazioni non valide o mancanti';
                    setModalShow(true);
                    return false;                    
                }
            }
            
        }

        if (comune.com_id == undefined) {
            msgText = "Inserisci le informazoni dell'indirizzo (comune) dove vuoi attivare la fornitura";
            msgTitle = 'Informazioni non valide o mancanti';
            setModalShow(true);
            return false;
        }

        if ((telet_id==undefined)||(telet_id==null)||(telet_id=="")){
            msgText = "Inserisci un tipo di indirizzo selezionandolo dalla lista delle proposte. Ad esempio VIA, STRADA, PIAZZA....";
            msgTitle = 'Informazioni non valide o mancanti';
            setModalShow(true);
            return false;                
        }

        if ((eletopo==undefined)||(eletopo==null)||(eletopo=="")){
            msgText = "Inserisci un indirizzo valido.";
            msgTitle = 'Informazioni non valide o mancanti';
            setModalShow(true);
            return false;                
        }

        if ((isNaN(cap)) || (cap.trim().length != 5)) {
            msgText = "Inserisci un CAP valido";
            msgTitle = 'Informazioni non valide o mancanti';
            setModalShow(true);
            return false;
        }


        if (isNaN(numero)) {
            msgText = "Inserisci un numero civico valido (solo parte numerica)";
            msgTitle = 'Informazioni non valide o mancanti';
            setModalShow(true);
            return false;
        }

        if (!ValidaCongruenzaContratto()){
            return false;
        }

        conx = {
            step: step,
            offertaEE: offertaEE,
            offertaGAS: offertaGAS,
            offertaEE_desc: offertaEE_desc,
            offertaEE_OT: offertaEE_OT,
            offertaGAS_desc: offertaGAS_desc,
            offertaGAS_OT: offertaGAS_OT,
            offertaEEObj:offertaEEObj,
            offertaGASObj:offertaGASObj,
            potenza: potenza,
            conAnnuoPrevEE: conAnnuoPrevEE,
            conAnnuoPrevGAS: conAnnuoPrevGAS,
            pod: pod,
            pdr: pdr,
            uf_nazione: 'ITALIA',
            uf_id_toponimo: telet_id,
            uf_toponimo: telet.toUpperCase().trim(),
            uf_via: eletopo.toUpperCase().trim(),
            uf_descrizione_comune: comune.com_des.toUpperCase().trim(),
            uf_comune: comune.com_id,
            uf_cap: cap,
            uf_civico: numero.trim(),
            uf_suffisso: suffisso.toUpperCase().trim().substring(0,5)   
        };


        StepContext.contratto = { ...StepContext.contratto, ...conx };
        sendCurrentState();

        return true;
    }

    return (
        <UECard BackButton={true} NextButton={true} className="S1Div" style={{ marginLeft: "250px", width: "100%", textAlign: "center", marginTop: "50px" }} onValidate={Validation}>
            <h2 style={{color:"green"}}><b>Manca poco! Completa i campi sottostanti</b></h2>
            <h2>Stai per attivare l'offerta</h2>
            <Row className="justify-content-center" style={{ display: 'flex'}} >
                {ModuloOfferteEE()}
                {ModuloOffertGas()}
            </Row>
            <hr />
            <Row className="justify-content-center" style={{ display: 'flex' }} >
                {ModuloDatiTecniciEE()}
                {ModuloDatiTecniciGas()}

            </Row>
            <hr />
            {/*ModuloUbicazione()*/}


            <h3 style={{ margin: "0 auto", maxWidth: "800px", textAlign: "center" }}>
                Ubicazione della Fornitura
            </h3>
            <Container className="container-fluid">
                <Row className="justify-content-center" style={{ display: 'flex' }} >
                    <Col className="col-md-auto">
                        <label htmlFor="comune" >
                            Comune*<br />
                            <ComuneAutoSuggest inputText={comuneDesc} id="comune" onSelectValue={(s) => { setComune(s); setCAP(s.com_cap); }} />
                        </label>
                    </Col>
                    <Col className="col-md-auto">
                        <label htmlFor="cap">
                            CAP<br />
                            <input type="text" className="ue ue-text" id="cap" placeholder="CAP"
                                maxLength="5" value={cap} onChange={(e) => { setCAP(e.target.value) }} />
                        </label>
                    </Col>

                </Row>
                <Row className="justify-content-center" style={{ display: 'flex' }} >
                    <Col className="col-md-auto">
                        <label htmlFor="tipo" >
                            Tipo indirizzo* (Via, Piazza, Strada...)<br />
                            <TipoIndAutoSuggest inputText={telet} id="tipo" onSelectValue={(s) => { setTeletID(s.telet_id); setTelet(s.telet_des) }} onChange={(e) => { setTelet(e); setTeletID(""); setTelet("") }} />
                        </label>
                    </Col>
                    <Col className="col-md-auto">
                        <label htmlFor="via">
                            Indirizzo*<br />
                            <IndirizzoAutoSuggest inputText={eletopo} com_id={comune.com_id} id="via" onSelectValue={(s) => { seEletID(s.elet_id); setEletopo(s.indirizzo) }} onChange={(e) => { setEletopo(e) }} />
                        </label>
                    </Col>
                </Row>
                <Row className="justify-content-center" style={{ display: 'flex' }} >
                    <Col className="col-md-auto">
                        <label htmlFor="numero" >
                            Numero*<br />
                            <input type="text" className="ue ue-text" id="numero" placeholder="Numero Civico"
                                value={numero} onChange={(e) => { setNumero(e.target.value) }} />
                        </label>
                    </Col>
                    <Col className="col-md-auto">
                        <label htmlFor="suffisso">
                            Suffisso<br />
                            <input type="text" className="ue ue-text" id="suffisso" placeholder="Suffisso"
                                value={suffisso} onChange={(e) => { setSuffisso(e.target.value.toUpperCase().substring(0,5)) }} />
                        </label>
                    </Col>
                </Row>
            </Container>



            <ModalPopup title={msgTitle} message={msgText} show={modalShow} onHide={() => setModalShow(false)} />

        </UECard>

    );
}

export default Step5;